import { render, staticRenderFns } from "./MultiplierBreakdownTab.vue?vue&type=template&id=a097bda8&scoped=true"
import script from "./MultiplierBreakdownTab.vue?vue&type=script&lang=js"
export * from "./MultiplierBreakdownTab.vue?vue&type=script&lang=js"
import style0 from "./MultiplierBreakdownTab.vue?vue&type=style&index=0&id=a097bda8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a097bda8",
  null
  
)

export default component.exports